import React from "react";
import * as styles from "../../newStyles.styles";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import StoreWebComponent from "./StoreWebComponent/index";
import AboutUsWebComponent from "./AboutUsWebComponent/index";
import RewardsWebComponent from "./RewardsWebComponent/index";
import DealsWebComponent from "./DealsWebComponent/index";
import PunchcardsWebComponent from "./PunchcardsWebComponent/index";
import ImageTitleTextWebComponent from "./ImageTitleTextWebComponent/index";
import ImageGalleryWebComponent from "./ImageGalleryWebComponent/index";
import TitleTextWebComponent from "./TitleTextWebComponent";
import CartWebComponent from "./CartWebComponent/index";
import CheckoutWebComponent from "./CheckoutWebComponent/index";
import ConfirmWebComponent from "./ConfirmWebComponent/index";

// Setup Stripe.js and the Elements provider
const stripePromise = loadStripe(__STRIPE_API_KEY__);

function WebPageController(props) {
  const WebTemplates = {
    store: (
      <StoreWebComponent history={props.history} isAdmin={props.isAdmin} />
    ),
    aboutUs: <AboutUsWebComponent />,
    rewards: <RewardsWebComponent />,
    deals: <DealsWebComponent />,
    punchCard: <PunchcardsWebComponent />,
    imageTitleText: <ImageTitleTextWebComponent />,
    titleText: <TitleTextWebComponent />,
    pictureCatalog: <ImageGalleryWebComponent />,
    cart: <CartWebComponent history={props.history} isAdmin={props.isAdmin} />,
    checkout: (
      <Elements stripe={stripePromise}>
        <CheckoutWebComponent history={props.history} isAdmin={props.isAdmin} />
      </Elements>
    ),
    confirm: (
      <ConfirmWebComponent history={props.history} isAdmin={props.isAdmin} />
    ),
  };
  const renderWebTemplate = () => {
    if (props.activeTemplate) {
      return WebTemplates[props.activeTemplate.type];
    } else if (props.history.location.state) {
      return WebTemplates[props.history.location.state.path];
    } else {
      return null;
    }
  };

  return (
    <main
      style={{
        width: "100%",
        minHeight: "calc(100vh - 70px)",
        backgroundColor: "rgb(255, 255, 255)",
        flex: "1 0 auto",
      }}
    >
      <div className={styles.row + " " + styles.webWrapper}>
        <div className={styles.col + " " + styles.col1}>
          <styles.H3 style={{ margin: "20px 0px 20px" }}>
            {props.activeTemplate.pageName}
          </styles.H3>
          {renderWebTemplate()}
        </div>
      </div>
    </main>
  );
}

export default WebPageController;
